"use strict";
/*
 *  Copyright (C) 2019  Attila Aldemir <a_aldemir@hotmail.de>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as published
 *  by the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = -1] = "NO_ERROR";
    ErrorCode[ErrorCode["UNKNOWN"] = 500] = "UNKNOWN";
    ErrorCode[ErrorCode["CONNECTION_ERROR"] = 501] = "CONNECTION_ERROR";
    ErrorCode[ErrorCode["NODE_ERROR"] = 502] = "NODE_ERROR";
    ErrorCode[ErrorCode["ATTESTATION_CONTEXT_NOT_FOUND"] = 503] = "ATTESTATION_CONTEXT_NOT_FOUND";
    ErrorCode[ErrorCode["WRONG_NUMBER_OF_DATA_FIELDS"] = 504] = "WRONG_NUMBER_OF_DATA_FIELDS";
    ErrorCode[ErrorCode["WRONG_VERSION_LENGTH"] = 505] = "WRONG_VERSION_LENGTH";
    ErrorCode[ErrorCode["WRONG_VERSION"] = 506] = "WRONG_VERSION";
    ErrorCode[ErrorCode["WRONG_ENTITY_TYPE_LENGTH"] = 507] = "WRONG_ENTITY_TYPE_LENGTH";
    ErrorCode[ErrorCode["WRONG_ENTITY_TYPE"] = 508] = "WRONG_ENTITY_TYPE";
    ErrorCode[ErrorCode["UNKNOWN_ENTITY_TYPE"] = 509] = "UNKNOWN_ENTITY_TYPE";
    ErrorCode[ErrorCode["WRONG_STATE_TYPE_LENGTH"] = 510] = "WRONG_STATE_TYPE_LENGTH";
    ErrorCode[ErrorCode["STATE_ALREADY_SET"] = 511] = "STATE_ALREADY_SET";
    ErrorCode[ErrorCode["DEPRECATE_STATE_CANNOT_BE_SET"] = 512] = "DEPRECATE_STATE_CANNOT_BE_SET";
    ErrorCode[ErrorCode["UNKNOWN_STATE_TYPE"] = 513] = "UNKNOWN_STATE_TYPE";
    ErrorCode[ErrorCode["ENTITY_NOT_ACTIVE"] = 514] = "ENTITY_NOT_ACTIVE";
    ErrorCode[ErrorCode["ENTITY_INACTIVE"] = 515] = "ENTITY_INACTIVE";
    ErrorCode[ErrorCode["WRONG_REDIRECT_ACCOUNT_LENGTH"] = 516] = "WRONG_REDIRECT_ACCOUNT_LENGTH";
    ErrorCode[ErrorCode["INVALID_REDIRECT_ACCOUNT"] = 517] = "INVALID_REDIRECT_ACCOUNT";
    ErrorCode[ErrorCode["PAYLOAD_TOO_LONG"] = 518] = "PAYLOAD_TOO_LONG";
    ErrorCode[ErrorCode["PAYLOAD_ALREADY_SET"] = 519] = "PAYLOAD_ALREADY_SET";
    ErrorCode[ErrorCode["ATTESTATION_NOT_ALLOWED"] = 520] = "ATTESTATION_NOT_ALLOWED";
    ErrorCode[ErrorCode["ATTESTATION_CONTEXT_ALREADY_SET"] = 521] = "ATTESTATION_CONTEXT_ALREADY_SET";
    ErrorCode[ErrorCode["SELF_ATTESTATION_NOT_ALLOWED"] = 522] = "SELF_ATTESTATION_NOT_ALLOWED";
    ErrorCode[ErrorCode["LEAF_ATTESTOR_NOT_ALLOWED"] = 523] = "LEAF_ATTESTOR_NOT_ALLOWED";
    ErrorCode[ErrorCode["END_ENTITY_NOT_ROOT"] = 524] = "END_ENTITY_NOT_ROOT";
    ErrorCode[ErrorCode["ROOT_ENTITY_IN_MIDDLE_OF_PATH"] = 525] = "ROOT_ENTITY_IN_MIDDLE_OF_PATH";
    ErrorCode[ErrorCode["INVALID_SIGNATURE"] = 526] = "INVALID_SIGNATURE";
    ErrorCode[ErrorCode["WRONG_CREATOR_ACCOUNT"] = 527] = "WRONG_CREATOR_ACCOUNT";
    ErrorCode[ErrorCode["CREATOR_ACCOUNT_DEPRECATED"] = 528] = "CREATOR_ACCOUNT_DEPRECATED";
    ErrorCode[ErrorCode["SIGNED_DATA_CALLBACK_ERROR"] = 529] = "SIGNED_DATA_CALLBACK_ERROR";
    ErrorCode[ErrorCode["ENTITY_CALLBACK_ERROR"] = 530] = "ENTITY_CALLBACK_ERROR";
    ErrorCode[ErrorCode["TOO_MANY_DEPRECATION_HOPS"] = 531] = "TOO_MANY_DEPRECATION_HOPS";
    ErrorCode[ErrorCode["ENTITY_MISMATCH"] = 532] = "ENTITY_MISMATCH";
    ErrorCode[ErrorCode["TRUSTED_ROOT_NOT_FOUND"] = 533] = "TRUSTED_ROOT_NOT_FOUND"; // 533
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var EntityType;
(function (EntityType) {
    EntityType["ROOT"] = "r";
    EntityType["INTERMEDIATE"] = "i";
    EntityType["LEAF"] = "l";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
var State;
(function (State) {
    State["ACTIVE"] = "a";
    State["INACTIVE"] = "i";
    State["DEPRECATED"] = "d";
})(State = exports.State || (exports.State = {}));
